import directives from './module';
import {Utils} from 'underscore-extensions';

class ContentEditable {
    ngModel: ng.INgModelController;

    constructor(private $scope: ng.IScope,
                private $element: ng.IAugmentedJQuery,
                private $filter: ng.IFilterService) {
    }

    $onInit() {
        if (!this.ngModel) return;

        const read = () => {
            const text = this.$filter('stripTags')(
                this.$element.html()
                    .replace(/<br>/g, '\n')
                    .replace(/&nbsp;/g, ' ')
                    .replace(/&amp;/g, '&')
                    .trim()
            );
            this.ngModel.$setViewValue(text);
        };

        this.ngModel.$render = () => this.$element.html((this.ngModel.$viewValue || ''));


        Utils.scopedEvent('paste', this.$scope, (e: ClipboardEvent) => {
            e.preventDefault();
            document.execCommand('insertText', false, e.clipboardData.getData('text/plain'));
        }, this.$element[0]);

        Utils.scopedEvent('keypress', this.$scope, (e: KeyboardEvent) => {
            if (e.which === 13 && (!e.shiftKey && !e.altKey && !e.ctrlKey && !e.metaKey)) { //disable enter but allow special+enter
                e.preventDefault();
                // (<HTMLElement>document.activeElement).blur();
            }
        }, this.$element[0]);
        this.$element.on('blur keyup change', () => this.$scope.$evalAsync(read));
    }
}
directives.directive('contenteditable', (): ng.IDirective => ({
        restrict: 'A',
        bindToController: true,
        require: {ngModel: '?ngModel'},
        controller: ContentEditable
    })
);




// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/ContentEditable.ts